/**
 * Back Button DOM Component
 *
 * Renders the "Go back" button (chevron icon) for listingHeader.dom.js, which needs it toggled
 * programmatically (shown only for VIEW_SOLD_FULL_LIST) — headers with an always-visible back
 * button render it inline in their own template instead (floorPlanDetailHeader.dom.js,
 * housingUnitDetailHeader.dom.js).
 *
 * @module nativeInteractiveSiteMap/components/backButton.dom
 */

import fastdom from 'fastdom';
import { backButtonIconSvg } from 'constants/svg-assets';

export default function createBackButton() {
  const buttonElement = document.createElement('button');
  buttonElement.type = 'button';
  buttonElement.className = 'nhs-c-native-interactive-site-map__back-button';
  buttonElement.setAttribute('aria-label', 'Go back');
  buttonElement.setAttribute('data-back-button', '');
  buttonElement.setAttribute('data-qa', 'native_ism_back_button');
  buttonElement.innerHTML = backButtonIconSvg;

  let clickHandler = null;

  return {
    getElement() {
      return buttonElement;
    },
    onClick(callback) {
      clickHandler = callback;
      buttonElement.addEventListener('click', callback);
    },
    show() {
      fastdom.mutate(() => {
        buttonElement.hidden = false;
      });
    },
    hide() {
      fastdom.mutate(() => {
        buttonElement.hidden = true;
      });
    },
    remove() {
      if (clickHandler) {
        buttonElement.removeEventListener('click', clickHandler);
        clickHandler = null;
      }
      fastdom.mutate(() => {
        buttonElement.remove();
      });
    },
  };
}
